import React, { useRef, useEffect } from 'react';
import './SponsorMockupModal.css';

const SponsorMockupModal = ({ isOpen, onClose, isClass = false }) => {
  const modalRef = useRef(null);
  const overlayRef = useRef(null);

  // Add classes for animation when modal opens
  useEffect(() => {
    if (isOpen && modalRef.current && overlayRef.current) {
      // Small delay to ensure elements are in DOM before adding classes
      setTimeout(() => {
        modalRef.current.classList.add('active');
        overlayRef.current.classList.add('active');
      }, 10);
    }
  }, [isOpen]);

  // Handle closing with animation
  const handleClose = (e) => {
    if (e) {
      e.stopPropagation();
    }
    
    if (modalRef.current) {
      modalRef.current.classList.remove('active');
    }
    
    if (overlayRef.current) {
      overlayRef.current.classList.remove('active');
    }
    
    // Wait for animation to finish before actually closing
    setTimeout(() => {
      onClose(e);
    }, 300);
  };

  const handleClickOutside = (e) => {
    e.stopPropagation();
    
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose(e);
    }
  };

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  // Render the modal within the phone frame instead of using a portal
  return (
    <div className="sponsor-mockup-modal-overlay" ref={overlayRef} onClick={handleClickOutside}>
      <div className="sponsor-mockup-modal-container" ref={modalRef} onClick={handleModalContentClick}>
        <div className="sponsor-mockup-modal-content">
          {/* Sponsorship Mockup - matches the design from MainLanding */}
          <div className="sponsorship-mockup">
            <h4 className="mockup-title">
              {isClass ? 'Dedicate This Class' : 'Sponsor This Event'}
            </h4>
            <div className="sponsorship-header">
              <div className="sponsorship-title-line"></div>
              <button className="close-btn" onClick={handleClose}>×</button>
            </div>
            <div className="sponsorship-amount-section">
              <div className="amount-label-line"></div>
              <div className="suggested-amount">
                {isClass ? '$120' : '$500'}
              </div>
              <div className="amount-description-line"></div>
            </div>
            <div className="sponsorship-note">
              <div className="note-line"></div>
            </div>
            <div className="payment-options">
              <div className="payment-option venmo">
                <div className="payment-icon venmo-icon">V</div>
                <span className="payment-name">Venmo</span>
                <div className="copy-icon">📋</div>
              </div>
              <div className="payment-option zelle">
                <div className="payment-icon zelle-icon">Z</div>
                <span className="payment-name">Zelle</span>
                <div className="copy-icon">📋</div>
              </div>
              <div className="payment-option paypal">
                <div className="payment-icon paypal-icon">P</div>
                <span className="payment-name">PayPal</span>
                <div className="external-icon">🔗</div>
              </div>
              <div className="payment-option cashapp">
                <div className="payment-icon cashapp-icon">$</div>
                <span className="payment-name">Cash App</span>
                <div className="copy-icon">📋</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorMockupModal;
